<template>
  <div v-if="formLevel == 1" class="pmc-right">
    <h1>
      Set New Password<span></span>
    </h1>
    <p class="mt-8">Secure Your Account with a New Password</p>
    <p class="pmc-right-p1 mt-2">Welcome back. As part of our security update, please set a new password to continue.
    </p>
    <form @submit.prevent="handlePasswordChange" class="mt-8">
      <div class="mt-4">
        <label>New Password</label>
        <div class="password-div-wrapper">
          <input id="newPassword" v-model="newPassword" :type="newPasswordInputType" name="new password"
            placeholder="x x x x x x" autocomplete="off" />
          <span class="toggle-password flex items-center justify-between px-2" @click="toggleNewPasswordVisibility">
            <EyeVisible v-if="isNewPasswordVisible" />
            <EyeHide v-else />
          </span>
        </div>
      </div>
      <div class="mt-4">
        <label>Confirm New Password</label>
        <div class="password-div-wrapper">
          <input id="confirmNewPassword" v-model="confirmNewPasswword" :type="confirmNewPasswordInputType" name="confirm new password"
            placeholder="x x x x x x" autocomplete="off" />
          <span class="toggle-password flex items-center justify-between px-2"
            @click="toggleConfirmNewPasswordVisibility">
            <EyeVisible v-if="isConfirmNewPasswordVisible" />
            <EyeHide v-else />
          </span>
        </div>
        <p v-if="passwordError" class="text-red-500 text-xs mt-1 font-mono">{{ passwordError }}</p>
      </div>
      <button class="mt-8" type="submit">
        Update & Continue
      </button>
    </form>
  </div>

  <div v-else-if="formLevel == 2" class="pmc-right">
    <h1>
      Congratulations !<span></span>
    </h1>
    <p class="mt-8">Password Reset Successful</p>
    <p class="pmc-right-p1 mt-2">Your password has been updated successfully. You can now log in using your new
      credentials.</p>
    <button class="mt-8" @click="redirectToLogin">
      Log In to Your Account
    </button>
  </div>
</template>

<script>
// import { ref } from 'vue'
import Web3 from 'web3';
import EyeHide from "@/decast/icons/EyeHide.vue";
import EyeVisible from "@/decast/icons/EyeVisible.vue";

export default {
  data() {
    return {
      formLevel: 1,
      newPassword: '',
      confirmNewPasswword: '',
      passwordError: '',
      isNewPasswordVisible: false,
      isConfirmNewPasswordVisible: false,
    };
  },
  components: {
    EyeHide,
    EyeVisible,
  },
  mounted() {
    document.getElementById('loading-bg-transparent').style.display = 'none';
  },
  computed: {
    newPasswordInputType() {
      return this.isNewPasswordVisible ? 'text' : 'password';
    },
    confirmNewPasswordInputType() {
      return this.isConfirmNewPasswordVisible ? 'text' : 'password';
    },
  },
  methods: {
    updateFormLevel(formLevel) {
      this.formLevel = formLevel;
    },
    toggleNewPasswordVisibility() {
      this.isNewPasswordVisible = !this.isNewPasswordVisible;
    },
    toggleConfirmNewPasswordVisibility() {
      this.isConfirmNewPasswordVisible = !this.isConfirmNewPasswordVisible;
    },
    redirectToLogin(){
      this.$router.push('/v2login');
    },
    handlePasswordChange() {
      if (!this.newPassword || !this.confirmNewPasswword) {
        this.passwordError = 'Please fill all the fields'
        return;
      }
      if (this.newPassword !== this.confirmNewPasswword) {
        this.passwordError = 'Confirm Password does not match with the New Password.'
        return;
      }
      this.passwordError = ''
      document.getElementById('loading-bg-transparent-title').innerText = '📩 Sending reset password link to email';
      document.getElementById('loading-bg-transparent').style.display = 'flex';
      const payload = {
        password: this.newPassword,
        hash: this.$route.query.hash,
      };
      this.$store
        .dispatch('auth/v2changePassword', payload)
        .then((response) => {
          if (response?.status === 204) {
            this.$vs.notify({
              title: 'Successful!',
              text: 'Password has been changed successfully',
              iconPack: 'feather',
              icon: 'icon-check-circle',
              color: 'success',
            });
            this.updateFormLevel(2);
          }
        })
        .catch((error) => {
          // Safely extract the specific error message
          const errorResponse = error.response?.data;
          let message = "An error occurred.";
          if (errorResponse?.errors?.email) {
            message = "Account does not exist!";
          } else if (errorResponse?.errors?.password) {
            message = errorResponse?.errors?.password;
          } else if (typeof errorResponse?.errors === 'string') {
            message = errorResponse.errors;
          }
          this.$vs.notify({
            title: 'Failed to send reset link',
            text: message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger',
          });
        }).finally(() => {
          document.getElementById('loading-bg-transparent').style.display = 'none';
        });
    },
  }
}
</script>

<style scoped>
*:not(i) {
  /* font-family: 'Karla', sans-serif !important; */
  font-family: 'Rethink Sans' !important;
}

button:disabled {
  opacity: 0.5;
  cursor: not-allowed !important;
}

#checkbox {
  width: unset !important;
  margin-top: 0px !important;
  margin-right: 10px !important;
  width: 16px !important;
  height: 16px !important;
  cursor: pointer;
}

.pmc-right {
  position: relative;
  overflow: hidden;
  width: 80%;
  height: 100%;
  padding: 70px 70px 0px 70px;
}

.pmc-right p {
  color: #FFFFFF;
}

.pmc-right h1 {
  color: #FFFFFF;
  font-size: 40px;
  line-height: 120%;
}

.pmc-right h1 span {
  color: #D7DF23;
}

.pmc-right .pmc-right-p1 {
  color: #BCBCBC;
  font-size: 14px;
  margin-top: 10px;
  margin-bottom: 24px;
  cursor: pointer;
}

.pmc-right label {
  font-size: 14px;
  color: #FFFFFF;
}

.pmc-right input {
  background: #15161F;
  border: 1px solid #444551;
  color: #FFFFFF;
  padding: 0.75rem !important;
  border-radius: 8px !important;
  width: 100% !important;
  outline: 2px solid transparent !important;
  outline-offset: 2px !important;
  margin-top: 6px;
}

.pmc-right button {
  background: #D7DF23;
  border: 1px solid #D7DF23;
  color: #000000;
  padding: 0.75rem;
  border-radius: 12px;
  width: 100%;
  outline: 2px solid transparent;
  outline-offset: 2px;
  cursor: pointer;
  transition: transform 0.05s ease-in-out;
}

.pmc-right button:active {
  transform: scale(0.99);
}

.password-div-wrapper {
  margin-top: 6px;
  position: relative;
}

.password-div-wrapper input {
  margin-top: 6px;
  margin-top: 0px;
}

.password-div-wrapper span {
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  cursor: pointer;
}

.check-box-label {
  color: #BCBCBC;
  font-size: 12px;
}

.sep-line {
  background-color: #444551;
  opacity: 0.5;
}

.sep-line-label {
  color: #FFFFFF50;
  background-color: #1B1D29;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
}

p.text-lime-400 {
  color: #D7DF23;
  display: inline-block;
  margin-top: 12px;
}

@media (max-width: 1024px) {
  .pmc-right {
    width: 100%;
    padding: 70px 40px;
  }
}

@media (max-width: 768px) {}

@media (max-width: 480px) {
  .pmc-right {
    padding: 20px;
  }
}
</style>
